/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */
import {
    HttpClient,
    HttpHeaders,
    HttpResponse as AngularHttpResponse,
} from '@angular/common/http';
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    BuildingAccessControlOrganisationUsersResponse,
    BuildingAccessControlOrganisationsResponse,
    BuildingAccessRequestDecisionResponse,
    BuildingAccessRequestListResponse,
    DecideBuildingAccessRequestRequest,
    InviteBuildingAccessControlUserRequest,
    ListBuildingAccessControlOrganisationUsersParams,
    ListBuildingAccessControlOrganisationsParams,
    RecipientBatchResponseOfInviteBuildingAccessControlUserResponse,
    RecipientOrganisationPreviewRequest,
    RecipientOrganisationPreviewResponse,
} from '../core-models';

interface HttpClientOptions {
    readonly headers?: HttpHeaders | Record<string, string | string[]>;
    readonly context?: HttpContext;
    readonly params?:
        | HttpParams
        | Record<
              string,
              string | number | boolean | Array<string | number | boolean>
          >;
    readonly reportProgress?: boolean;
    readonly withCredentials?: boolean;
    readonly credentials?: RequestCredentials;
    readonly keepalive?: boolean;
    readonly priority?: RequestPriority;
    readonly cache?: RequestCache;
    readonly mode?: RequestMode;
    readonly redirect?: RequestRedirect;
    readonly referrer?: string;
    readonly integrity?: string;
    readonly referrerPolicy?: ReferrerPolicy;
    readonly transferCache?: { includeHeaders?: string[] } | boolean;
    readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
    readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
    readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
    readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
    readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue =
    | string
    | number
    | boolean
    | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys?: ReadonlySet<string>,
    preserveRequiredNullables?: false,
    passthroughKeys?: undefined
): Record<string, AngularHttpParamValue>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> | undefined,
    preserveRequiredNullables: true,
    passthroughKeys?: undefined
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> | undefined,
    preserveRequiredNullables: boolean | undefined,
    passthroughKeys: ReadonlySet<string>
): Record<string, unknown>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> = new Set(),
    preserveRequiredNullables = false,
    passthroughKeys: ReadonlySet<string> = new Set()
): Record<string, unknown> {
    const filteredParams: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(params)) {
        if (passthroughKeys.has(key)) {
            if (value !== undefined) {
                filteredParams[key] = value;
            }
            continue;
        }
        if (Array.isArray(value)) {
            const filtered = value.filter(
                (item) =>
                    item != null &&
                    (typeof item === 'string' ||
                        typeof item === 'number' ||
                        typeof item === 'boolean')
            ) as Array<string | number | boolean>;
            if (filtered.length) {
                filteredParams[key] = filtered;
            }
        } else if (value === null && requiredNullableKeys.has(key)) {
            // With a paramsSerializer (preserveRequiredNullables) the literal null
            // is passed through for it to consume; without one, emit an empty
            // string so the required key still reaches the wire as `?key=`
            // instead of being silently dropped. See #3712.
            filteredParams[key] = preserveRequiredNullables ? null : '';
        } else if (
            value != null &&
            (typeof value === 'string' ||
                typeof value === 'number' ||
                typeof value === 'boolean')
        ) {
            filteredParams[key] = value;
        }
    }
    return filteredParams;
}

@Injectable({ providedIn: 'root' })
export class BuildingAccessControlApiService {
    private readonly http = inject(HttpClient);
    /**
     * Invites one to 20 comma-delimited recipients to a building and assigns the shared building-level role.
     * @summary Invite user to building access control
     */
    inviteBuildingAccessControl<
        TData = RecipientBatchResponseOfInviteBuildingAccessControlUserResponse,
    >(
        buildingId: string,
        inviteBuildingAccessControlUserRequest: InviteBuildingAccessControlUserRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    inviteBuildingAccessControl<
        TData = RecipientBatchResponseOfInviteBuildingAccessControlUserResponse,
    >(
        buildingId: string,
        inviteBuildingAccessControlUserRequest: InviteBuildingAccessControlUserRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    inviteBuildingAccessControl<
        TData = RecipientBatchResponseOfInviteBuildingAccessControlUserResponse,
    >(
        buildingId: string,
        inviteBuildingAccessControlUserRequest: InviteBuildingAccessControlUserRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    inviteBuildingAccessControl<
        TData = RecipientBatchResponseOfInviteBuildingAccessControlUserResponse,
    >(
        buildingId: string,
        inviteBuildingAccessControlUserRequest: InviteBuildingAccessControlUserRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/access-control/invite`,
                inviteBuildingAccessControlUserRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/access-control/invite`,
                inviteBuildingAccessControlUserRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/access-control/invite`,
            inviteBuildingAccessControlUserRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Read-only exact-email lookup. Returns recognised, unknown or unavailable; only recognised includes an organisation name. Preview is not invitation eligibility or authorisation.
     * @summary Preview an existing building invite recipient's organisation
     */
    createBuildingAccessControlInviteRecipientPreview<
        TData = RecipientOrganisationPreviewResponse,
    >(
        buildingId: string,
        recipientOrganisationPreviewRequest: RecipientOrganisationPreviewRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingAccessControlInviteRecipientPreview<
        TData = RecipientOrganisationPreviewResponse,
    >(
        buildingId: string,
        recipientOrganisationPreviewRequest: RecipientOrganisationPreviewRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingAccessControlInviteRecipientPreview<
        TData = RecipientOrganisationPreviewResponse,
    >(
        buildingId: string,
        recipientOrganisationPreviewRequest: RecipientOrganisationPreviewRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingAccessControlInviteRecipientPreview<
        TData = RecipientOrganisationPreviewResponse,
    >(
        buildingId: string,
        recipientOrganisationPreviewRequest: RecipientOrganisationPreviewRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/access-control/invite/recipient-preview`,
                recipientOrganisationPreviewRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/access-control/invite/recipient-preview`,
                recipientOrganisationPreviewRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/access-control/invite/recipient-preview`,
            recipientOrganisationPreviewRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Lists organisations with access to the specified building.
     * @summary List organisations with access to a building
     */
    listBuildingAccessControlOrganisations<
        TData = BuildingAccessControlOrganisationsResponse,
    >(
        buildingId: string,
        params: ListBuildingAccessControlOrganisationsParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingAccessControlOrganisations<
        TData = BuildingAccessControlOrganisationsResponse,
    >(
        buildingId: string,
        params: ListBuildingAccessControlOrganisationsParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingAccessControlOrganisations<
        TData = BuildingAccessControlOrganisationsResponse,
    >(
        buildingId: string,
        params: ListBuildingAccessControlOrganisationsParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingAccessControlOrganisations<
        TData = BuildingAccessControlOrganisationsResponse,
    >(
        buildingId: string,
        params: ListBuildingAccessControlOrganisationsParams,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/access-control/organisations`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/access-control/organisations`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/access-control/organisations`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Removes a non-owner organisation from building access control.
     * @summary Remove organisation access from a building
     */
    removeBuildingAccessControlOrganisation<TData = void>(
        buildingId: string,
        targetOrganisationId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    removeBuildingAccessControlOrganisation<TData = void>(
        buildingId: string,
        targetOrganisationId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    removeBuildingAccessControlOrganisation<TData = void>(
        buildingId: string,
        targetOrganisationId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    removeBuildingAccessControlOrganisation<TData = void>(
        buildingId: string,
        targetOrganisationId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/access-control/organisations/${targetOrganisationId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.delete<TData>(
                `/@core/api/buildings/${buildingId}/access-control/organisations/${targetOrganisationId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.delete<TData>(
            `/@core/api/buildings/${buildingId}/access-control/organisations/${targetOrganisationId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Lists users with building access for a specific organisation on the selected building.
     * @summary List users for a building access-control organisation
     */
    listBuildingAccessControlOrganisationUsers<
        TData = BuildingAccessControlOrganisationUsersResponse,
    >(
        buildingId: string,
        targetOrganisationId: string,
        params: ListBuildingAccessControlOrganisationUsersParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listBuildingAccessControlOrganisationUsers<
        TData = BuildingAccessControlOrganisationUsersResponse,
    >(
        buildingId: string,
        targetOrganisationId: string,
        params: ListBuildingAccessControlOrganisationUsersParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingAccessControlOrganisationUsers<
        TData = BuildingAccessControlOrganisationUsersResponse,
    >(
        buildingId: string,
        targetOrganisationId: string,
        params: ListBuildingAccessControlOrganisationUsersParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingAccessControlOrganisationUsers<
        TData = BuildingAccessControlOrganisationUsersResponse,
    >(
        buildingId: string,
        targetOrganisationId: string,
        params: ListBuildingAccessControlOrganisationUsersParams,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/access-control/organisations/${targetOrganisationId}/users`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/access-control/organisations/${targetOrganisationId}/users`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/access-control/organisations/${targetOrganisationId}/users`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Lists pending organisation access requests for a building. Only Building Owners can access this endpoint.
     * @summary List pending building access requests
     */
    listBuildingAccessControlRequests<
        TData = BuildingAccessRequestListResponse,
    >(buildingId: string, options?: HttpClientBodyOptions): Observable<TData>;
    listBuildingAccessControlRequests<
        TData = BuildingAccessRequestListResponse,
    >(
        buildingId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listBuildingAccessControlRequests<
        TData = BuildingAccessRequestListResponse,
    >(
        buildingId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listBuildingAccessControlRequests<
        TData = BuildingAccessRequestListResponse,
    >(
        buildingId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/access-control/requests`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/buildings/${buildingId}/access-control/requests`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/buildings/${buildingId}/access-control/requests`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Approves or rejects a pending building access request. Only Building Owners can decide requests.
     * @summary Decide a building access request
     */
    createBuildingAccessControlRequest<
        TData = BuildingAccessRequestDecisionResponse,
    >(
        buildingId: string,
        requestId: string,
        decideBuildingAccessRequestRequest: DecideBuildingAccessRequestRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createBuildingAccessControlRequest<
        TData = BuildingAccessRequestDecisionResponse,
    >(
        buildingId: string,
        requestId: string,
        decideBuildingAccessRequestRequest: DecideBuildingAccessRequestRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createBuildingAccessControlRequest<
        TData = BuildingAccessRequestDecisionResponse,
    >(
        buildingId: string,
        requestId: string,
        decideBuildingAccessRequestRequest: DecideBuildingAccessRequestRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createBuildingAccessControlRequest<
        TData = BuildingAccessRequestDecisionResponse,
    >(
        buildingId: string,
        requestId: string,
        decideBuildingAccessRequestRequest: DecideBuildingAccessRequestRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/access-control/requests/${requestId}`,
                decideBuildingAccessRequestRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/buildings/${buildingId}/access-control/requests/${requestId}`,
                decideBuildingAccessRequestRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/buildings/${buildingId}/access-control/requests/${requestId}`,
            decideBuildingAccessRequestRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
}
